module.exports = __webpack_public_path__ + "static/icons/icon-webcam--white-2f34f2258f780c86aef51f2827eea2d1.svg";